import dynamic from 'next/dynamic';
import { CoBrandCreditCardProps } from './CoBrandCreditCard.types';

export const CoBrandCreditCardMGP = dynamic<CoBrandCreditCardProps>(() => import('./CoBrandCreditCard'));
// import('./CoBrandCreditCard').then(module => module.CoBrandCreditCard)

export const CoBrandPlaceholder = dynamic(() => import('./CoBrandPlaceholder'));